export const LISTE_COMMANDES = {
  title: 'Liste des commandes',
  breadcrumb: {
    liste: 'Liste des commandes',
  },
  actions: {
    add: 'Nouvelle commande',
  },
  table: {
    code: 'Commande n°',
    dateDevisCommande: 'Date',
    fournisseur: 'Fournisseur',
    etat: 'Etat',
    montantHt: 'Montant HT',
    montantTtc: 'Montant TTC',
  },
  filtre: {
    etat: 'Etat(s)',
    fournisseur: 'Fournisseur(s)',
    code: 'Code',
    dateDevisCommande: 'Date commande',
  },
};

export const DETAIL_COMMANDE = {
  title: 'Détail commande n° {code}',
  breadcrumb: {
    liste: 'Liste des commandes',
    title: 'Détail commande',
  },
  tabs: {
    informationsTab: 'Informations',
    echeancierFacturationTab: 'Échéancier de facturation',
    lieuDeLivraisonTab: 'Lieu de livraison',
  },
  anchor: {
    commande: 'Commande',
    comments: 'Commentaires',
    piecesJointes: 'Pièces jointes',
  },
  actions: {
    receptionner: 'Receptionner',
  },
  lieuLivraison: {
    title: 'Lieu(x) de livraison(s)',
    table: {
      produit: 'Produit',
      libelle: 'Libelle',
      quantite: 'Quantité',
      nbLieuLivraison: 'Lieu(x) de Livraison(s)',
      lieuLivraison: 'Lieu de livraison',
      quantiteCommandee: 'Quantité commandée',
      quantiteReceptionnee: 'Quantité réceptionnée',
      solde: 'Solde',
    },
  },
  facturer: 'Facturer',
  sansSuiteTitle: 'Etes-vous sûr de vouloir classer sans suite cette commande ?',
  suppressionTitle: 'Etes-vous sûr de vouloir supprimer cette commande ?',
  suppressionMessageSuccess: 'La commande a été supprimée avec succès.',
  errors: {
    isLinkedToNeeds: 'La commande ne peut pas être supprimée car elle est liée à un ou plusieurs besoins.',
  },
  edition: {
    commandeWithLieuxLivraison: 'Commande avec lieu(x) de livraison',
    lieuxLivraison: 'Lieu(x) de livraison',
  },
};

export const ADD_EDIT_COMMANDE = {
  title: {
    add: 'Ajouter une commande',
    edit: 'Modifier la commande n°',
  },
  breadcrumb: {
    add: 'Ajouter une commande',
    edit: 'Modifier une commande',
    liste: 'Liste des commandes',
  },
  notifications: {
    successCreation: 'Commande créée avec succès',
    successChange: 'Commande modifiée avec succès',
  },
  tabs: {
    informationsTab: 'Informations',
    echeanciersTab: 'Échéancier de facturation',
    lieuDeLivraisonTab: 'Lieu(x) de livraison(s)',
  },
  informations: {
    title: 'Commande d\'achat',
    labelIntervenant: 'Fournisseur',
    labelObjet: 'Objet de la commande',
    labelDate: 'Date de la commande',
    labelReference: 'Référence de la commande',
    labelReferenceExterne: 'N° Commande de vente',
  },
  errors: {
    commandeVenteSansSuite: 'La commande de vente liée ne peut pas être a l\'état sans suite',
    cantBeChangeIfBesoin: 'La commande de vente liée ne peut pas être modifié sur une commande issue d\'un besoin',
    wrongStateForSansSuite: 'La commande d\'achat ne peut pas être passée sans suite au vu de son état',
  },
  lieuLivraison: {
    title: 'Lieu(x) de livraison(s)',
    table: {
      produit: 'Produit',
      libelle: 'Libelle',
      quantite: 'Quantité',
      nbLieuLivraison: 'Lieu(x) de Livraison(s)',
      lieuLivraison: 'Lieu de livraison',
    },
    errors: {
      quantite: 'La quantite lié au lieu de livraison',
      lieuLivraison: 'Le lieu de livraison',
      sameQuantite: 'La somme des quantités des lieux de livraisons doit être égale à la quantité de la ligne',
      uniqueLieux: 'Le lieu de livraison doit être unique pour chaque ligne',
    },
  },
};
